import {
  getCompanyListData,
  _getCSelectItemDataById,
} from '../companies/mockData'
import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import type { TEntityId } from '~/types/models'
import type { ICompanyTeamMember } from '@/types/companyTeamMember/models'
import {
  _getTMDataById,
  getTeamMemberListData,
} from '~/api/msw/api/teamMembers/mockData'
import {
  TeamMemberRoleIds,
  getTeamMemberRoleById,
} from '~/services/selectLists/teamMemberRoles'

const companyTeamMemberListData = undefined as unknown as ICompanyTeamMember[]

export const getCompanyTeamMemberListData = getListDataFunctionFactory<
  ICompanyTeamMember[]
>({
  listData: companyTeamMemberListData,
  storageKey: 'companyteammembers',
  getStartingListData: getStartingCompanyTeamMemberListData,
})

export async function getCompanyTeamMemberListDataByCompanyId(id: TEntityId) {
  const ctmListData = await getCompanyTeamMemberListData()
  return ctmListData.filter((ctm: ICompanyTeamMember) => ctm.company.id === id)
}

export async function getStartingCompanyTeamMemberListData(): Promise<
  ICompanyTeamMember[]
> {
  const cList = await getCompanyListData()
  const tmList = await getTeamMemberListData()
  return [
    {
      id: 'XXCTM0001',
      hrid: 'CTM0001',
      company: _getCSelectItemDataById('XXC0001', cList),
      teamMember: _getTMDataById('XXTM0001', tmList),
      role: getTeamMemberRoleById(TeamMemberRoleIds.ACCOUNT_OWNER),
      status: {
        id: 2,
        label: 'Active',
      },
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXCTM0003',
      hrid: 'CTM0003',
      company: _getCSelectItemDataById('XXC0001', cList),
      teamMember: _getTMDataById('XXTM0003', tmList),
      role: getTeamMemberRoleById(TeamMemberRoleIds.SALES_SUPPORT),
      status: {
        id: 2,
        label: 'Active',
      },
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXCTM0004',
      hrid: 'CTM0004',
      company: _getCSelectItemDataById('XXC0001', cList),
      teamMember: _getTMDataById('XXTM0004', tmList),
      role: getTeamMemberRoleById(TeamMemberRoleIds.SOLUTION_ENGINEER),
      status: {
        id: 2,
        label: 'Active',
      },
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXCTM0005',
      hrid: 'CTM0005',
      company: _getCSelectItemDataById('XXC0001', cList),
      teamMember: _getTMDataById('XXTM0005', tmList),
      role: getTeamMemberRoleById(TeamMemberRoleIds.SUB_AGENT),
      status: {
        id: 2,
        label: 'Active',
      },
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXCTM0006',
      hrid: 'CTM0006',
      company: _getCSelectItemDataById('XXC0001', cList),
      teamMember: _getTMDataById('XXTM0006', tmList),
      role: getTeamMemberRoleById(TeamMemberRoleIds.ENGINEER),
      status: {
        id: 2,
        label: 'Active',
      },
      version: '1',
      canBeDeleted: true,
    },
  ]
}
